const styles = (isMobile) => ({
  container: {
    padding: isMobile ? "16px" : "2vh 0vw",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "32px",
  },
  title: {
    fontWeight: 600,
    color: "#0D0D0E",
    marginBottom: "8px",
    fontSize: isMobile ? "24px" : "28px",
    lineHeight: 1.2,
  },
  subtitle: {
    color: "#666",
    fontSize: isMobile ? "14px" : "16px",
    fontWeight: 400,
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 20px",
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 20px",
    color: "#666",
  },
  emptyStateTitle: {
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "12px",
    color: "#333",
  },
  chartsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "24px",
  },
  chartCard: {
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    backgroundColor: "#ffffff",
    boxShadow: "none",
  },
  chartTitle: {
    fontWeight: 500,
    color: "#0D0D0E",
    marginBottom: "16px",
  },
  chartPlaceholder: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "128px",
    backgroundColor: "#f9fafb",
    borderRadius: "8px",
  },
  roomCard: {
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    backgroundColor: "#ffffff",
    boxShadow: "none",
    overflow: "hidden",
  },
  roomHeader: {
    padding: "24px",
    borderBottom: "1px solid #f5f5f5",
  },
  roomIcon: {
    fontSize: "24px",
  },
  roomName: {
    fontWeight: 600,
    color: "#0D0D0E",
    fontSize: "20px",
    letterSpacing: 0,
    marginBottom: 0,
  },
  totalChip: {
    backgroundColor: "#e8f5e8",
    color: "#2e7d32",
    fontWeight: 600,
    fontSize: "12px",
  },
  expandButton: {
    minWidth: "auto",
    padding: "8px",
    color: "#666",
    boxShadow: "none",
    backgroundColor: "transparent",
    fontSize: "24px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  inclusionsContainer: {
    borderTop: "1px solid #f5f5f5",
  },
  inclusionItem: {
    padding: "24px",
    paddingLeft: "48px",
    backgroundColor: "#fafafa",
    borderBottom: "1px solid #f0f0f0",
  },
  inclusionIcon: {
    fontSize: "20px",
  },
  inclusionName: {
    fontWeight: 500,
    color: "#0D0D0E",
    fontSize: "18px",
    letterSpacing: 0,
    marginBottom: 0,
  },
  inclusionChip: {
    backgroundColor: "#fff3e0",
    color: "#f57c00",
    fontWeight: 600,
    fontSize: "12px",
  },
  boqsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  addItemButton: {
    width: "100%",
    marginTop: "16px",
    padding: "12px",
    fontSize: "14px",
    fontWeight: 500,
    color: "#4D6BF6",
    backgroundColor: "#ffffff",
    border: "1px solid #D7D8D9",
    borderRadius: "8px",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#f3f8ff",
      borderColor: "#4D6BF6",
    },
  },
  availableInclusionsTitle: {
    fontWeight: 500,
    color: "#0D0D0E",
    marginBottom: "16px",
  },
  availableInclusionsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  inclusionButton: (isAlreadyAdded) => ({
    padding: ".7vh 1vw",
    fontSize: "12px",
    fontWeight: 500,
    borderRadius: "8px",
    textTransform: "none",
    boxShadow: "none",
    ...(isAlreadyAdded
      ? {
        color: "#999",
        backgroundColor: "#f5f5f5",
        border: "1px solid #e0e0e0",
        cursor: "not-allowed",
      }
      : {
        color: "#666",
        backgroundColor: "#ffffff",
        border: "1px solid #D7D8D9",
        "&:hover": {
          backgroundColor: "#f5f5f5",
          color: "#333",
          borderColor: "#999",
        },
      }),
  }),
  inclusionCard: {
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    backgroundColor: "#ffffff",
    boxShadow: "none",
    overflow: "hidden",
  },
  inclusionHeader: {
    padding: "24px",
    borderBottom: "1px solid #f5f5f5",
  },
  roomInInclusion: {
    padding: "24px",
    paddingLeft: "48px",
    backgroundColor: "#fafafa",
    borderBottom: "1px solid #f0f0f0",
  },
  boqItem: {
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    padding: "16px",
    border: "1px solid #e0e0e0",
  },
  boqImageContainer: {
    width: "48px",
    height: "48px",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#e0e0e0",
    flexShrink: 0,
  },
  itemName: {
    fontWeight: 500,
    color: "#0D0D0E",
    fontSize: "14px",
    whiteSpace: "nowrap",
  },
  typeChip: {
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
    fontWeight: 500,
    fontSize: "10px",
  },
  boqDetailsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gap: "16px",
    alignItems: "center",
    minWidth: "600px",
  },
  boqDetailItem: {
    textAlign: "center",
    minWidth: "80px",
  },
  disabledButton: {
    padding: "4px 12px",
    fontSize: "12px",
    fontWeight: 500,
    color: "#999",
    backgroundColor: "#f5f5f5",
    borderRadius: "6px",
    textTransform: "none",
    cursor: "not-allowed",
  },
  deleteButton: {
    padding: "4px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#f44336",
    borderRadius: "6px",
    minWidth: "auto",
    cursor: "not-allowed",
  },
});

export default styles;
